import { render, staticRenderFns } from "./cinema.vue?vue&type=template&id=27f409c6&scoped=true"
import script from "./cinema.vue?vue&type=script&lang=js"
export * from "./cinema.vue?vue&type=script&lang=js"
import style0 from "./cinema.vue?vue&type=style&index=0&id=27f409c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f409c6",
  null
  
)

export default component.exports